import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../../common/TableHead";
import { WebhookAuthSummary } from "../../../common/WebhookAuthFields";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
import { canEditSiteWebhooks } from "./SiteAboutPageUtils/siteWebhooks";

export const WEBHOOKS_TAB_TITLES = [
  "Display Name",
  "Webhook Type",
  "Method",
  "Target URL",
  "Message Body",
  "Authentication",
];

const capitalize = (value: string | null | undefined) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : "";

/**
 * Site About → Webhooks: one row per site webhook (ENG-2233). The "+ Add
 * Webhook" button opens AddSiteWebhookDialog through the site-about store so
 * the many tab-render call sites don't need another prop.
 */
export const WebhooksTab = ({ webhooksInfo }: { webhooksInfo: any }) => {
  const setAddSiteWebhookDialogOpen = useSiteAboutStore(
    (state) => state.setAddSiteWebhookDialogOpen
  );
  const webhooks: any[] = Array.isArray(webhooksInfo) ? webhooksInfo : [];
  const canAdd = canEditSiteWebhooks();

  const addButton = (
    <OrangeTextButton
      onClick={() => setAddSiteWebhookDialogOpen(true)}
      text="+ Add Webhook"
      disabled={false}
    />
  );

  return (
    <TableContainer component={Paper} sx={{ width: "screen" }}>
      {webhooks.length > 0 && (
        <>
          {canAdd && (
            <div
              className="flex justify-end pr-[10px] pt-[6px]"
              data-testid="webhooks-tab-actions"
            >
              {addButton}
            </div>
          )}
          <Table
            sx={{
              postion: "absolute",
              width: "screen",
              fontFamily: "Mulish",
            }}
          >
            <TableHeadComponent titlesArray={WEBHOOKS_TAB_TITLES} />

            <TableBody>
              {webhooks.map((webhook: any) => (
                <TableRow
                  key={webhook.id}
                  data-testid={`site-webhook-row-${webhook.id}`}
                >
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    {webhook.display_name}
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    {capitalize(webhook.webhook_type)}
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    {webhook.method}
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    {webhook.target_url}
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    {webhook.message_body}
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    <WebhookAuthSummary webhook={webhook} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      )}
      {webhooks.length === 0 && (
        <div
          className="flex flex-col items-center gap-3 py-10"
          data-testid="webhooks-tab-empty"
        >
          <p className="font-mulish text-[#283E6D] text-[20px] text-center m-0">
            No webhooks configured for this site.
          </p>
          {canAdd && addButton}
        </div>
      )}
    </TableContainer>
  );
};
